import React from 'react';

const Warning = ({ width = 20, height = 20, color = '#F27500', className = '' }) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.56211 4.0625H11.437L10.9995 10.3125H8.99955L8.56211 4.0625ZM8.34961 13.8375C8.34961 12.9262 9.08836 12.1875 9.99961 12.1875C10.9109 12.1875 11.6496 12.9262 11.6496 13.8375C11.6496 14.7487 10.9109 15.4875 9.99961 15.4875C9.08836 15.4875 8.34961 14.7487 8.34961 13.8375Z" fill="white" />
    </svg>
  );
};

export default Warning;
